import * as React from 'react';
import MainIcon from './assets/pin.svg';

export const MainPinIcon: React.FC = () => {
  return <img src={MainIcon} alt="" />;
};
